import { IProviderScheduleSummary } from 'model/v2';
import { formatProviderName } from 'utils/format/providerName';

type ScheduleProvider = IProviderScheduleSummary['provider'];

export const btLabelOf = (provider: ScheduleProvider) =>
  provider.specialty?.abbreviation
    ? `${formatProviderName(provider)} (${provider.specialty.abbreviation})`
    : formatProviderName(provider);

export const btLegalLabelOf = (provider: ScheduleProvider) =>
  provider.specialty?.abbreviation
    ? `${provider.firstName} ${provider.lastName} (${provider.specialty.abbreviation})`
    : `${provider.firstName} ${provider.lastName}`;
